import React, {useEffect} from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { profile } from '../../config/profile'

export default function Skills() {
    useEffect(() => {
        AOS.init({duration:1000})
    }, [])
    
    return (
        <section className="skills-area page-section scroll-to-page" id="skills">
            <div className="custom-container">
                <div className="skills-content content-width">
                    <div className="section-header">
                        <h4 className="subtitle scroll-animation" data-aos='fade-up'>
                            <i className="las la-shapes"></i> Technical Skills
                        </h4>
                        <h1 className="scroll-animation" data-aos='fade-up'>Core <span>Expertise</span></h1>
                    </div>

                    {profile.skills.map((category, index) => (
                        <div key={category.category} className="skill-category mb-5">
                            <h3 className="scroll-animation" data-aos='fade-up'>{category.category}</h3>
                            <div className="row skills text-center">
                                {category.items.map((skill, skillIndex) => (
                                    <div key={skill.name} 
                                         className="col-md-3 scroll-animation" 
                                         data-aos={skillIndex % 2 === 0 ? 'fade-right' : 'fade-left'}>
                                        <div className="skill">
                                            {skill.useStyle===false ? (
                                            <div className="skill-inner">
                                                <img  src={`../assets/images/skills/${skill.icon}`} alt={skill.name} />
                                                <p className="name">{skill.name}</p>                                                
                                            </div>
                                            ) : (
                                                <div className="skill-inner1">
                                                    <img  src={`../assets/images/skills/${skill.icon}`} alt={skill.name} />
                                                    <p className="name">{skill.name}</p>                                                
                                                </div>
                                            )}
                                            
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
